<script lang="ts" module>
	export interface TableHeaderProps {
		dataCy: string;
		width?: string | undefined;
		class?: string;
		custom?: import('svelte').Snippet;
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Txt } from '../../Txt';

	let { dataCy, width = undefined, custom, children, ...rest }: TableHeaderProps = $props();
</script>

<th
	class={twMerge('border-y px-3 py-4 text-left', rest.class)}
	style={width ? `width: ${width};` : undefined}
	data-cy={`${dataCy}-header`}
>
	{#if custom}
		{@render custom?.()}
	{:else}
		<Txt variant="label3" component="div">{@render children?.()}</Txt>
	{/if}
</th>
